import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import {
  GlobalDifferentialRatesResponseDto,
  ManageScheduledDifferentialRatesDto,
  ScheduleDifferentialRatesResponseDto,
  UpdateGlobalDifferentialRatesResponseDto,
  UpdateGlobalDifferentialSettingsDto
} from '../dtos';
@Injectable({ providedIn: 'root' })
export class BillableRatesService {
  private http = inject(HttpClient);
  private readonly baseUrl = 'api/Admin/global-differential-rates';

  getAll(): Observable<GlobalDifferentialRatesResponseDto> {
    return this.http.get<GlobalDifferentialRatesResponseDto>(this.baseUrl);
  }

  update(
    payload: UpdateGlobalDifferentialSettingsDto
  ): Observable<UpdateGlobalDifferentialRatesResponseDto> {
    return this.http.put<UpdateGlobalDifferentialRatesResponseDto>(
      `${this.baseUrl}`,
      payload
    );
  }

  updateSchedule(
    payload: ManageScheduledDifferentialRatesDto
  ): Observable<ScheduleDifferentialRatesResponseDto> {
    return this.http.put<ScheduleDifferentialRatesResponseDto>(
      `${this.baseUrl}/scheduled`,
      payload
    );
  }

  getScheduledRate(
    scope: ScopeOfPracticeEnum
  ): Observable<ScheduleDifferentialRatesResponseDto> {
    return this.http.get<ScheduleDifferentialRatesResponseDto>(
      `${this.baseUrl}/${scope}/scheduled`
    );
  }
}
